import { FC, useState } from "react";
import { InputProps } from "./InputProps";
import { SurveyPostObject } from "../../service/apiHelper";

export const Dropdown: FC<{
  inputProps: InputProps;
  handleChange: Function;
}> = ({ inputProps, handleChange }) => {
  const dropDownOptions = [{ label: "--", value: "" }, ...inputProps.options!];
  const [value, setDropdownValue] = useState(dropDownOptions[0].label);

  const onChangeHandler = (event: any) => {
    setDropdownValue(event.target.value);

    // if (event.target.value !== dropDownOptions[0].label) {
    const newProps: SurveyPostObject = {
      SurveyId: inputProps.id,
      SurveyLabel: inputProps.label,
      ResponseText: event.currentTarget.value,
      ResponseValue: event.currentTarget.value,
    };
    handleChange(newProps);
    // }
  };

  return (
    <div className="">
      {inputProps.label !== null && (
        <label
          htmlFor={inputProps.label}
          className="block text-sm font-normal leading-6 text-gray-900"
        >
          {inputProps.label}{" "}
          {inputProps.required && <span className="text-error-600">*</span>}
        </label>
      )}

      <div className="relative mt-2 rounded-md ">
        <div className="inset-y-0 left-0 flex items-center ">
          <select
            value={value}
            onChange={onChangeHandler}
            name={inputProps.id}
            id={inputProps.id}
            className="block w-full rounded-md border-0 py-1.5 text-gray-900  ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-primary-600 sm:text-sm sm:leading-6"
          >
            {dropDownOptions.map((item) => (
              <option key={item.label}>{item.label}</option>
            ))}
          </select>
        </div>
      </div>
    </div>
  );
};
